import get from 'lodash/get'

const yandexMetrikaReachGoal = (targetName: string) => {
  if (
    typeof ym !== 'undefined' &&
    typeof Ya !== 'undefined' &&
    Ya &&
    typeof Ya._metrika !== 'undefined'
  ) {
    const counters = get(Ya._metrika.getCounters(), '[0].id')
    if (!counters) return

    const counterIds = Array.isArray(counters) ? counters : [counters]
    counterIds.forEach((counter) => ym(counter, 'reachGoal', targetName))
  }
}

export const analyticsReachGoal = (targetName: string) => {
  yandexMetrikaReachGoal(targetName)
}
